module.exports = __webpack_public_path__ + "static/media/TeamsAssets-Light.d7d7eb79.woff2";